import { z } from 'zod';
import { dashboardLayoutSchema } from './dashboard-dto';
import { publishedSwimlaneResponseSchema } from './published-swimlane-dto';
import { publishedTimelineResponseSchema } from './published-timeline-dto';

// hiddenFieldIds is `readonly string[]` on PublishedSwimlaneResponse but mutable here -- a
// runtime-identical divergence documented in published-swimlane-dto.ts. Type against the
// interface and let this schema validate at the boundary rather than casting between them.
const swimlanePanelContentSchema = z.object({
  kind: z.literal('swimlane'),
  viewId: z.number().int(),
  data: publishedSwimlaneResponseSchema,
});

const timelinePanelContentSchema = z.object({
  kind: z.literal('timeline'),
  viewId: z.number().int(),
  data: publishedTimelineResponseSchema,
});

export const dashboardPanelUnavailableReasonSchema = z.enum([
  'widget',
  'unsupported',
  'empty',
  'failed',
]);
export type DashboardPanelUnavailableReason = z.infer<typeof dashboardPanelUnavailableReasonSchema>;

const unavailablePanelContentSchema = z.object({
  kind: z.literal('unavailable'),
  reason: dashboardPanelUnavailableReasonSchema,
});

export const dashboardExportPanelContentSchema = z.discriminatedUnion('kind', [
  swimlanePanelContentSchema,
  timelinePanelContentSchema,
  unavailablePanelContentSchema,
]);
export type DashboardExportPanelContent = z.infer<typeof dashboardExportPanelContentSchema>;

export const dashboardExportPanelSchema = z.object({
  position: z.number().int().min(0),
  widthFraction: z.number().min(0).max(1).nullable(),
  heightPx: z.number().int().min(0).nullable(),
  content: dashboardExportPanelContentSchema,
});
export type DashboardExportPanel = z.infer<typeof dashboardExportPanelSchema>;

export const dashboardExportResponseSchema = z.object({
  dashboardId: z.number().int(),
  loopId: z.number().int(),
  name: z.string().nullable(),
  layout: dashboardLayoutSchema,
  panels: z.array(dashboardExportPanelSchema),
  exportedAt: z.iso.datetime(),
});
export type DashboardExportResponse = z.infer<typeof dashboardExportResponseSchema>;
